
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PrescriptionSelect from "./prescription-select.vue";
@Component({
    components: {
        PrescriptionSelect,
    }
})
export default class PrescriptionDialog extends Vue {
    @Prop({ type: Array, default: () => [] })
    private value!: any[];

    @Prop({ type: Boolean, default: false })
    private visible!: boolean;
    @Watch('visible')
    private onVisibleChange(newVal: boolean) {
        if (newVal) {
            this.ingredients = JSON.parse(JSON.stringify(this.value));
        }
    }

    private ingredients: any[] = [];

    private mounted() { }

    private handleMedicineChange(index: number, val: any) {
        // 适配新的数据格式
        if (this.ingredients[index].herb) {
            // 如果val是对象（包含id和name），则更新herb对象
            if (typeof val === 'object' && val.id && val.name) {
                this.ingredients[index].herb.id = val.id;
                this.ingredients[index].herb.name = val.name;
            } else {
                // 如果val只是字符串，则只更新name
                this.ingredients[index].herb.name = val;
            }
        } else {
            this.ingredients[index].name = val;
        }
    }

    private addIngredient() {
        this.ingredients.push({
            herb: {
                id: null,
                name: ""
            },
            quantity: "",
            unit: "g"
        });
    }

    private removeIngredient(index: number) {
        this.ingredients.splice(index, 1);
    }

    private cancel() {
        this.$emit('cancel');
    }

    private confirm() {
        // 过滤掉空的药材，适配新的数据格式
        const validIngredients = this.ingredients.filter(item => {
            const name = item.herb ? item.herb.name : item.name;
            return name && name.trim() !== '';
        });
        this.$emit('confirm', validIngredients);
    }
}
